export var tabsMixin = {
  data: function data() {
    return {
      DATA_OPERATOR: 'data operator',
      ACCOUNTABLE: 'accountable',
      tabIndex: 0,
      titleColor: '#044999'
    };
  },
  computed: {
    getTitleOwner: function getTitleOwner() {
      var _this = this;
      return function (tabIndex) {
        var title = "List all the";
        switch (tabIndex) {
          case 0:
            title = _this.traductor('my_objects.subtitle_access');
            break;
          case 1:
            title = _this.traductor('my_objects.subtitle_tables');
            break;
          case 2:
            title = _this.traductor('my_objects.subtitle_bterms');
            break;
          case 3:
            title = _this.traductor('my_objects.subtitle_datasources');
            break;
          case 4:
            title = _this.traductor('my_objects.subtitle_dashboards');
            break;
          case 5:
            title = _this.traductor('my_objects.subtitle_datasets');
            break;
          case 6:
            title = _this.traductor('my_objects.subtitle_reports');
            break;
          case 7:
            title = _this.traductor('my_objects.subtitle_reports_lds');
            break;
          case 8:
            title = _this.traductor('my_objects.subtitle_datasources_gds');
            break;
          default:
            title = '';
            break;
        }
        return title;
      };
    },
    getTitlePendings: function getTitlePendings() {
      var _this2 = this;
      return function (tabIndex) {
        var title = '';
        switch (tabIndex) {
          case 0:
            title = _this2.traductor('my_pendings.ownership.subtitle_tables');
            break;
          case 1:
            title = _this2.traductor('my_pendings.ownership.subtitle_datasources');
            break;
          case 2:
            title = _this2.traductor('my_pendings.ownership.subtitle_dashboards');
            break;
          case 3:
            title = _this2.traductor('my_pendings.ownership.subtitle_datasets');
            break;
          case 4:
            title = _this2.traductor('my_pendings.ownership.subtitle_reports');
            break;
          case 5:
            title = _this2.traductor('my_pendings.ownership.subtitle_reports_lds');
            break;
          case 6:
            title = _this2.traductor('my_pendings.ownership.subtitle_datasources_gds');
            break;
          default:
            title = '';
            break;
        }
        return title;
      };
    },
    getTitleAccess: function getTitleAccess() {
      var _this3 = this;
      return function (tabIndex) {
        var title = '';
        switch (tabIndex) {
          case 0:
            title = _this3.traductor('descripcion.a_my_tables');
            break;
          case 1:
            title = _this3.traductor('descripcion.a_my_datasources');
            break;
          case 2:
            title = _this3.traductor('descripcion.a_my_dashboards');
            break;
          case 3:
            title = _this3.traductor('descripcion.a_my_datasets');
            break;
          case 4:
            title = _this3.traductor('descripcion.a_my_reports');
            break;
          case 5:
            title = _this3.traductor('descripcion.a_my_gds');
            break;
          case 6:
            title = _this3.traductor('descripcion.a_my_gds_datasources');
            break;
          default:
            title = '';
            break;
        }
        return title;
      };
    },
    getTitleChange: function getTitleChange() {
      var _this4 = this;
      return function (tabIndex) {
        var title = '';
        switch (tabIndex) {
          case 0:
            title = _this4.traductor('my_pendings.metadata_.subtitle_tables');
            break;
          case 1:
            title = _this4.traductor('my_pendings.metadata_.subtitle_datasources');
            break;
          case 2:
            title = _this4.traductor('my_pendings.metadata_.subtitle_dashboards');
            break;
          case 3:
            title = _this4.traductor('my_pendings.metadata_.subtitle_datasets');
            break;
          case 4:
            title = _this4.traductor('my_pendings.metadata_.subtitle_reports');
            break;
          case 5:
            title = _this4.traductor('my_pendings.metadata_.subtitle_reports_lds');
            break;
          case 6:
            title = _this4.traductor('my_pendings.metadata_.subtitle_datasources_gds');
            break;
          default:
            title = '';
            break;
        }
        return title;
      };
    }
  },
  methods: {
    traductor: function traductor(key) {
      return this.$i18n.t(key);
    }
  }
};